import {Component, Inject} from "@angular/core";
import {contextPath, fgURL} from "site";
import * as user from "user";
import * as $ from "jquery";
import * as site from "site";
import {FeatureFlagService} from "fly-common/feature-flag.service";

@Component({
	selector: "secondary-navigation",
	template: `
		<nav class="navsecondary">
			<ul>
				<li><a routerLink="/overview" routerLinkActive="navsecondary_active">Overview</a></li>
				<ng-container *ngIf="useNewAircraftListPage; else oldAircraftListPage">
					<li><a [href]="newAircraftListPageUrl" routerLinkActive="navsecondary_active">Devices</a></li>
				</ng-container>
				<ng-template #oldAircraftListPage>
					<li><a routerLink="/list" routerLinkActive="navsecondary_active">Devices</a></li>
				</ng-template>
				<li><a routerLink="/database-pricing" routerLinkActive="navsecondary_active">Buy Databases</a></li>
				<li><a routerLink="/update-schedule" routerLinkActive="navsecondary_active">Update Schedule</a></li>
				<li><a routerLink="/warranty-registration" routerLinkActive="navsecondary_active">Warranty</a></li>
				<li><a href="${contextPath}/connext/satellite-services/">Connected-Cockpit Services</a></li>
				<li *ngIf="grantsExist"><a routerLink="/dealer-access-management" routerLinkActive="navsecondary_active">Manage Dealer Access</a></li>
				<li *ngIf="hasTransferAccess"><a routerLink="/transfer" routerLinkActive="navsecondary_active">Transfer Aircraft</a></li>
			</ul>
		</nav>
	`,
})
export class SecondaryNavigationComponent {
	user = user;
	userIsOem: boolean;
	grantsExist: boolean;
	useNewAircraftListPage: boolean = false;
	newAircraftListPageUrl: string = `${fgURL}aircraft/list`;

	constructor(@Inject("isOemUser") userIsOem: boolean, featureFlagService: FeatureFlagService) {
		this.userIsOem = userIsOem;
		this.getAllAccessGrants();
		featureFlagService.isNewAircraftListPageEnabled().subscribe((enabled) => {
			this.useNewAircraftListPage = enabled && this.user != null && this.user.customerUuid != null
		});
	}

	get hasTransferAccess(): boolean {
		return this.user.isDealer || this.userIsOem || this.user.isOemDistributor;
	}

	getAllAccessGrants() {
		if (this.user != null && this.user.customerUuid != null) {
			Promise.all([this.getUserDealerActiveAccessRequests(),
				this.getUserDealerPendingAccessRequests(),
				this.getUserDealerExpiredAccessRequests()])
				.then((requests) =>
					this.grantsExist = requests.some((request) => request.length > 0)
				)
				.catch(() => this.grantsExist = false);
		} else {
			this.grantsExist = false;
		}
	}

	// ================================================================================
	// Function for getting request for getting Active user dealer grants
	// ================================================================================
	getUserDealerActiveAccessRequests(): Promise<userDealerAccessGrantCustomerResponse[]> {
		return new Promise<userDealerAccessGrantCustomerResponse[]>((resolve, reject) => {
			$.ajax({
				type: 'GET',
				url: `${site.contextPath}/api/user-dealer-access-grants/active`,
				dataType: 'json',
				success: (activeRequests: userDealerAccessGrantCustomerResponse[]) => {
					resolve(activeRequests);
				},
				error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
					console.error(`${jqXHR.status} ${textStatus} ${errorThrown}`);
					reject();
				}
			});
		});
	}


	// ================================================================================
	// Function for getting Pending user dealer grants
	// ================================================================================
	getUserDealerPendingAccessRequests(): Promise<userDealerAccessGrantCustomerResponse[]> {
		return new Promise<userDealerAccessGrantCustomerResponse[]>((resolve, reject) => {
			$.ajax({
				type: 'GET',
				url: `${site.contextPath}/api/user-dealer-access-grants/pending`,
				dataType: 'json',
				success: (activeRequests: userDealerAccessGrantCustomerResponse[]) => {
					resolve(activeRequests);
				},
				error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
					console.error(`${jqXHR.status} ${textStatus} ${errorThrown}`);
					reject();
				}
			});
		});
	}

	// ================================================================================
	// Function for getting Expired user dealer grants
	// ================================================================================
	getUserDealerExpiredAccessRequests(): Promise<userDealerAccessGrantCustomerResponse[]> {
		return new Promise<userDealerAccessGrantCustomerResponse[]>((resolve, reject) => {
			$.ajax({
				type: 'GET',
				url: `${site.contextPath}/api/user-dealer-access-grants/expired`,
				dataType: 'json',
				success: (activeRequests: userDealerAccessGrantCustomerResponse[]) => {
					resolve(activeRequests);
				},
				error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
					console.error(`${jqXHR.status} ${textStatus} ${errorThrown}`);
					reject();
				}
			});
		});
	}
}

interface userDealerAccessGrantCustomerResponse {
	uuid: string;
	customerGuid: string;
	dealerCustomerGuid: string;
	acceptedDate: string;
	endDate: string;
	dealerName: string;
}
